import React from "react";

const GENDERS = [
  { value: "m", label: "Male" },
  { value: "f", label: "Female" },
];

// Shown, never submitted: the backend counts the requester on its own.
const TableRequestYouCard = ({ user = {} }) => {
  const gender = typeof user.gender === "object" ? user.gender?.value : user.gender;
  const field = (id, label, value, { full = false, type = "text" } = {}) => (
    <div className={`table-request-form__field${full ? " table-request-form__field--full" : ""}`}>
      <label className="table-request-form__label" htmlFor={`you-${id}`}>
        {label}
      </label>
      <input
        id={`you-${id}`}
        type={type}
        className="registration-form__input table-request-form__input"
        value={value || ""}
        disabled
        readOnly
      />
    </div>
  );

  return (
    <fieldset className="table-request-form__guest table-request-form__guest--you" disabled>
      <legend className="table-request-form__guest-title">Guest 1 · You</legend>
      <div className="table-request-form__grid">
        {field("first-name", "First name", user.firstName)}
        {field("last-name", "Last name", user.lastName)}
        {field("email", "Email", user.email, { full: true, type: "email" })}
        {field("mobile", "Mobile number", user.mobile, { type: "tel" })}
        <fieldset className="table-request-form__field table-request-form__fieldset">
          <legend className="table-request-form__label">Gender</legend>
          <div className="table-request-form__segments">
            {GENDERS.map((option) => (
              <label
                key={option.value}
                className={`table-request-form__segment${
                  gender === option.value ? " table-request-form__segment--selected" : ""
                }`}
              >
                <input type="radio" name="you-gender" value={option.value} checked={gender === option.value} disabled readOnly />
                {option.label}
              </label>
            ))}
          </div>
        </fieldset>
      </div>
    </fieldset>
  );
};

export default TableRequestYouCard;
